export const Navigation = [
    {
        text: 'Shipments',
        icon: 'box',
        items: [
            {
                text: 'Recents',
                path: '/admin/shipments/shipped-recents'
            },
            {
                text: 'In Transit',
                path: '/admin/shipments/shipped-intransit'
            },
            {
                text: 'Delivered',
                path: '/admin/shipments/shipped-delivered'
            },
            {
                text: 'Delivery Exceptions',
                path: '/admin/shipments/shipped-delivery-exceptions'
            },
            {
                text: 'Voided',
                path: '/admin/shipments/shipped-voided'
            }
        ]
    }
];